import { createReducer } from 'redux-act';
import * as actions from './assistTrip.actions';

const initialState = {
  loading: false,
  completed: false,
  errorMessage: '',
};

const assistTripReducer = createReducer(
  {
    [actions.completeLoading]: state => ({
      ...state,
      loading: false,
      completed: true,
    }),
    [actions.error]: (state, payload) => ({
      ...state,
      errorMessage: payload.message,
      loading: false,
      completed: false,
    }),
    [actions.addAssist]: state => ({
      ...state,
      loading: true,
    }),
    [actions.closeErrorModal]: state => ({
      ...state,
      errorMessage: '',
    }),
  },
  initialState,
);

export default assistTripReducer;
